import { render, staticRenderFns } from "./ViewMessage.vue?vue&type=template&id=6bdef7b7&"
import script from "./ViewMessage.vue?vue&type=script&lang=js&"
export * from "./ViewMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports